function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.75 4C3.75 3.30964 4.30964 2.75 5 2.75H13.2146C13.5301 2.75 13.834 2.86932 14.0652 3.08401L14.5755 2.53441L14.0652 3.08401L19.8506 8.45615C20.1053 8.69266 20.25 9.02455 20.25 9.37214V20C20.25 20.6904 19.6904 21.25 19 21.25H5C4.30964 21.25 3.75 20.6904 3.75 20V4Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 3V8C14 8.55228 14.4477 9 15 9H20",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 13H16",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 17H13",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgDocument3 = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDocument3, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Document-3.0feb6bd1.svg";
export { ForwardRef as ReactComponent };